// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"73d3a922","354":"52013f32","756":"eb825b34","838":"b04f42ea"}[chunkId] + ".js";
};